<script lang="ts">
	import { AchievementProgressState } from '../../../../domain/Achievement';
	import AchievementTrackingService from '$services/tracking/AchievementTrackingService';
	import { activateAchievement } from '$services/achievement/AchievementService';
	import { ActivationResult, ActivationSource } from '$services/tracking/Activation';
	import { findAchievementById } from '../../../../store/AchievementStore';

	const { variant, id, origin }: { variant: string, id: string, origin: ActivationSource } = $props();

	const variantMap: Record<string, {
		text: string;
		icon: string;
		size: string;
		disabled: true | undefined,
		ottoVariant: string,
		success: true | undefined,
		actionable: boolean
	}> = {
		cardActivation: {
			text: 'Jetzt aktivieren',
			icon: 'plus',
			size: '50',
			disabled: undefined,
			ottoVariant: 'primary',
			success: undefined,
			actionable: true
		},
		appOnlyCardActivation: {
			text: 'Nur in der App',
			icon: 'phone',
			size: '50',
			disabled: undefined,
			ottoVariant: 'primary',
			success: undefined,
			actionable: false
		},
		appOnlyInstructionsActivation: {
			text: 'In der App aktivieren',
			icon: 'phone',
			size: '100',
			disabled: true,
			ottoVariant: 'primary',
			success: undefined,
			actionable: false
		},
		instructionsActivation: {
			text: 'Challenge aktivieren',
			icon: 'plus',
			size: '100',
			disabled: undefined,
			ottoVariant: 'primary',
			success: undefined,
			actionable: true
		},
		appOnlyInstructionsActivated: {
			text: 'Aktiviert in der OTTO-App',
			icon: 'check',
			size: '100',
			disabled: true,
			ottoVariant: 'primary',
			success: true,
			actionable: false
		},
		instructionsActivated: {
			text: 'Aktiviert',
			icon: 'check',
			size: '100',
			disabled: true,
			ottoVariant: 'primary',
			success: true,
			actionable: false
		}
	};

	const data = variantMap[variant] || variantMap['cardActivation'];
	let loading: boolean = $state(false);
	const achievementTrackingService = new AchievementTrackingService();
	const achievement = findAchievementById(id);
	const disabled = data.disabled;
	const success = data.success;

	//@ts-ignore
	const processAchievementActivation = async (event) => {
		if (data.actionable && !loading) {
			event.stopPropagation();
			loading = true;
			const activationResource = await activateAchievement(achievement!.achievementId);
			loading = activationResource.loading;
			await achievementTrackingService.sendAchievementActivationFeatureTracking(
				achievement!,
				origin,
				activationResource.success ? ActivationResult.Success : ActivationResult.Failure
			);

			if (!activationResource.success) {
				document.dispatchEvent(new CustomEvent('achievementActivationFailed'));
				return;
			}

			if (activationResource.state == AchievementProgressState.ACTIVATED) {
				document.dispatchEvent(new CustomEvent('achievementActivated'));
			}
		}
	};
</script>

<oc-button-v1
	data-testid="activation-button"
	oc-aria-label={data.text}
	icon-type-right={data.icon}
	size={data.size}
	variant={data.ottoVariant}
	onclick={processAchievementActivation}
	{loading}
	{disabled}
	{success}
>
	{data.text}
</oc-button-v1>
